import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";

function ListButtons(props) {
  const [isAdmin, setIsAdmin] = useState(false);

  // MARK: Use Effect Method
  useEffect(() => {
    checkUserRole();
  }, []);

  // MARK: checkUserRole
  function checkUserRole() {
    const userInfo = JSON.parse(localStorage.getItem("session"));
    setIsAdmin(userInfo.role === "admin");
  }

  return (
    <div className="d-flex mt-3 text-start">
      <Button
        type="button"
        className="lists__edit_button"
        onClick={props.editclick}
        tooltip="edit"
        tooltipOptions={{ position: "bottom" }}
      >
        <span className="pi pi-pencil"></span>
      </Button>
     {isAdmin && <Button
        severity="secondary"
        type="button"
        onClick={props.deleteclick}
        className="lists__delete_button"
        tooltip="delete"
        tooltipOptions={{ position: "bottom" }}
      >
        <span className="pi pi-trash"></span>{" "}
      </Button>}
      <ToastContainer />
    </div>
  );
}

export default ListButtons;
